import {
  TreemapModule,
  createTreemapServices
} from "./chunk-QKX3RCWE.mjs";
import "./chunk-ORCS5NZH.mjs";
export {
  TreemapModule,
  createTreemapServices
};
